import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { addMonths, differenceInMilliseconds } from "date-fns";
import { catchError, filter, Observable, of, switchMap, throwError } from "rxjs";
import { environment } from "src/environments/environment";
import { AuthService } from "../services/auth.service";

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {
  private _refreshTokenInProgress: boolean = false;
  private _milisecondsBeforeTokenExpire = environment.minutesBeforeTokenExpire * 60 * 1000;
  private _excludedRequestsUrls: Array<string> = new Array<string>(
    'refresh-token',
    'logout',
    'login',
    'registration'
  );
  private _defaultDateWhenMissingExpiration = addMonths(new Date(), -1).toDateString();

  constructor(private auth: AuthService, private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    req = req.clone({
      withCredentials: true,
    });
    req = this.auth.setRequestHeader(req);

    const accessTokenExpireDate = localStorage.getItem('expiration') ||  this._defaultDateWhenMissingExpiration;
    if (!accessTokenExpireDate) return next.handle(req);
    if (this.checkIsAssetsRequest(req.url)) return next.handle(req);
    if (this.checkIsExcludedRequestForInterceptor(req.url)) return next.handle(req);

    const now = new Date();
    const tokenExpiryDate = new Date(accessTokenExpireDate);
    const expiryTimeLeft = differenceInMilliseconds(tokenExpiryDate, now);
    if (expiryTimeLeft < 0) {
      this.auth.logout(false);
      return of();
    }

    if (expiryTimeLeft < this._milisecondsBeforeTokenExpire && !this._refreshTokenInProgress) {
      this._refreshTokenInProgress = true;
      return this.auth.refreshToken()
        .pipe(
          catchError((err) => {
            this._refreshTokenInProgress = false;
            this.auth.logout(false);
            return throwError(() => err);
          }),
          switchMap(_ => {
            this._refreshTokenInProgress = false;
            return next.handle(this.auth.setRequestHeader(req));
          }),
        )
    }

    return of(this._refreshTokenInProgress)
      .pipe(
        filter(x => x === false),
        switchMap(_ => {
          return next.handle(req)
        })
      )
  }

  private checkIsExcludedRequestForInterceptor(url: string) {
    const indicator = environment.refreshTokenInterceptorExcludeIndicator;
    const index = url.indexOf(indicator);
    if (index >= 0) {
      const destination = url.substring(index + indicator.length);
      for (let requestUrl of this._excludedRequestsUrls) {
        if (new RegExp(requestUrl).test(destination)) {
          return true;
        }
      }
    }
    return false;
  }

  private checkIsAssetsRequest(url: string) {
    const indicator = 'assets';
    const index = url.indexOf(indicator);
    return index > -1 ? true : false;
  }

}
